<template>

  <span :class="[{'heading-icon':true},classes]" @click="clicked">

	<Icon :type="settings.icon" class="icon" />

	<span class="heading" v-html="settings.label" />

  </span>

</template>

<script>
import Icon from './Icon.vue'
export default {
  name: 'TableHeadingWithIcon',
  components: { Icon },
  props: {
	settings: {
	  type: Object,
	  default: () => {}
	}
  },
  data() {
  return {
    
  }
  },
  computed: {

    classes () {

      let c = this.settings.classes !== 'undefined' ? this.settings.classes : {};

      return c;

    }

  },
  methods: {
  
	clicked () {

	  this.$emit('clicked');

	}

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.heading-icon {

  display: block;
  padding: 14px 10px 13px;
  text-align: left;
  
  .icon {

	display: block;
	margin: 0;
	width: 20px;

  }

  .heading {

	display: block;
	margin-top: 4px;

  }

}
@media screen and (min-width: 960px) {

  .heading-icon {

    text-align: left;

  }

}
</style>